import _ from 'lodash'

import utility from '@/mixins/utility'

class Library {

  #data = {}

  #issues = []

  #ctas = []

  constructor(data={})
  {  
    this.#data = data

    this.#issues = utility.methods.mapModels(data.issues, 'issue')

    this.#ctas = utility.methods.mapModels(data.ctas, 'cta')
  }

  /**
   * Property getters.
   */
  
  get active()
  {
    return this.#data.active
  }

  get banner()
  {
    return this.#data.banner
  }

  get buyUrl()
  {
    return this.#data.buy_url
  }

  get canBuy()
  {
    return this.#data.can_buy
  }

  get canRead()
  {
    return this.#data.can_read
  }

  get collectionImage()
  {
    return this.#data.collection_image || ''
  }

  get cover()
  {
    return this.#data.cover
  }

  get ctaIcon()
  {
    return this.#data.cta_icon
  }

  get ctaLabel()
  {
    return this.#data.cta_label || 'Leggi'
  }

  get description()
  {
    return this.#data.description
  }

  get embed()
  {
    return this.#data.embed
  }

  get hasBought()
  {
    return this.#data.has_bought
  }

  get id()
  {
    return this.#data.id
  }

  get layout()
  {
    return this.#data.layout
  }

  get pdf()
  {
    return this.#data.pdf
  }

  get slug()
  {
    return this.#data.slug
  }

  get store()
  {
    return this.#data.store
  }

  get title()
  {
    return this.#data.title
  }

  /**
   * Relationships.
   */

  get ctas()
  {
    return this.#ctas
  }

  get issues()
  {
    return this.#issues
  }

  /**
   * Computed properties.
   */
  
  get hasFile()
  {
    return ( this.pdf || this.embed )
  }
  
  get hasIssues()
  {
    return this.issues.length > 0
  }

  get isGrid()
  {
    return this.layout === 'grid'
  }

  get isList()
  {
    return this.layout === 'list'
  }

  get pivot()
  {
    return this.#data.pivot ? this.#data.pivot : {}
  }

  get sortedIssues()
  {
    if( !this.hasIssues )
      return []

    /**
     * @todo ordino per release date
     */
    return _.orderBy( this.issues, ['order_column'], ['desc'] )
  }

  /**
   * Methods.
   */

  hasLoadPermission(name)
  {
    let permission = this.#data[name]

    return (typeof permission !== 'undefined')
  }
}

export default Library